import { useEffect, useMemo, useState } from "react";
import { RootDispatch, RootState } from "@store";
import { Me } from "@store/me/reducer";
import { useMe } from "@utils/hooks/useMe";
import { ROUTES_E } from "@utils/RoutsName";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout as logoutDispatch } from "../../store/auth/actions";
// import { getCookie } from "react-use-cookie";
import { show } from "redux-modal";
import { MODALS_ENUM } from "@constants/Modals";
import { clearServerTime } from "@utils/serverTime";
import AUTHSTATES from "@store/auth/AuthStates";
import useApiRequests from "@services/http/useApiRequest";
import { useLocale } from "@utils/hooks/useLocale";
import { isTokenAlive } from "@store/auth/cookieStorage";
import { AccountRecord, IAccount, UserRole } from "@services/http/responses/AccountResponse";
import { RecordResponse } from "@services/http/responses/BaseResponse";
import { AccountRequest } from "@services/http/auth";
import usePermissions from "@utils/hooks/usePermissions";

interface HeaderControlI {
  readonly isLogon: boolean;
  readonly isAdmin?: boolean;
  readonly isRus: boolean;
  readonly me?: Me;
  setLocale(l: "RU" | "EN"): void;
  toAccount(): void;
  logout(tag: string): void;
  createMinerRate(): void;
}

export const useHeaderControl = () => {

  const me = useMe();
  const auth = useSelector((state: RootState) => state.auth); //useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch() as RootDispatch;
  const { isRus, setLocale } = useLocale();
  const [showRoleSwithcher, setShowRoleSwitcher] = useState(false);
  const requests = useApiRequests();
  const [account, setAccount] = useState<IAccount>();
  const { canSwitchRole } = usePermissions();

  const toAccount = () => navigate(`/account/${me?.email.value}`);

  const logout = async (tag: string) => {
    dispatch(logoutDispatch(tag));
    try {
      await fetch("/api/logoff");
    } catch {
      // даже если произошла ошибка надо чтобы код ниже выполнился
    }
    navigate(ROUTES_E.HOME);
    clearServerTime();
  };

  const createMinerRate = () => dispatch(show(MODALS_ENUM.CREATE_PLAN_MODAL));

  useEffect(() => {
    if (!canSwitchRole) {
      setShowRoleSwitcher(false);
      return;
    }
    if (me?.role === UserRole.Admin || me?.role === UserRole.User) {
      setShowRoleSwitcher(true);
    } else {
      setShowRoleSwitcher(false);
    }
  }, [me?.role, setShowRoleSwitcher, canSwitchRole]);

  useEffect(() => {
    (async () => {
      if (!me?.email.value) return;
      const data = await requests.enqueue<RecordResponse<AccountRecord>>(
        new AccountRequest({ email: me?.email.value })
      );
      if (!data) return;
      setAccount(data.Record.account);
    })();
  }, [me?.email]);

  const userEmail = useMemo(() => {
    return me?.email?.value || "";
  }, [me]);

  return {
    isRus,
    isAdmin: auth.isAdmin,
    isLogon: auth.state === AUTHSTATES.AUTHORIZED && isTokenAlive(),
    userEmail,
    me,
    showRoleSwithcher,
    account,
    setLocale,
    toAccount,
    logout,
    createMinerRate,
  };
};
